<template>
  <!-- User Add Pop up -->
  <b-modal id="addRepNuera" centered size="md" no-close-on-backdrop hide-footer hide-header-close >
    <template #modal-header>

<div class="headergroup">
      <!-- this header will be always visible -->
      <div class="addRep-header">
        <h4 v-if="!showOtpModal" class="text-center">Add Rep User</h4>
      </div>

      <div class="otpmodalheader">
        <h4 v-if="showOtpModal" class="text-center mb-3"> Validate {{ otpType }} via OTP</h4>
        </div>
        </div>
    <b-button variant="close-btn" class='btn-container' @click="closeModal" id="crossbtn">
      <i class="fas fa-times"></i>
    </b-button>
    </template>
   
    <b-container fluid class="px-0">
      <div class="addRep-form">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">

          <form  v-if="!showOtpModal"
            @submit.stop.prevent="handleSubmit(create)"
            ref="addRepAdminContainer"
          >


            <input-text 
            :rules="{ required: true, email: true }"

              labelFor="email"
              labelName="Email Address"
              :vmodel.sync="form.email"
              formGroupClass="form-group"
              inputType="email"
            />
            
            <div class=" row justify-content-between validation-row mt-2 mb-1"
              :class="showOtpSectionEmail ? 'rep-otp-validation mb-3' : 'mb-1'"
              id="emailOTP">

              <a v-if="showOtpSectionEmail"
                href="#" 
                class="validate-via-otp-link validate-btn" 
                @click.prevent="sendOtp('email')"
              >
                TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL. 
              </a>
            
            </div>
            <!-- to show the error message for the email -->
            <div v-if="emailMsg" class="contacts-message-container form-group">
                   <div :class="['validate-message', emailValidationMessage.type]">
                   <div :class="['message-indicator', `${emailValidationMessage.type}-indicator`]"></div>
                       <span class="message-text">
                          <strong :class="`${emailValidationMessage.type}-text`">{{ emailValidationMessage.title }}</strong> - 
                          {{ emailValidationMessage.message }}
                        </span>
               </div>
            </div>
            <input-text
              :rules="{ required: true, digits: 10 }"
              labelFor="phone"
              labelName="Phone"
              :vmodel.sync="form.phone"
              formGroupClass="form-group mt-2"
              inputType="number"
             @keypress.native="onlyAllowDigits"
              maxlength="10"
              inputmode="numeric"
             pattern="\d*"

            />
            <div class=" row justify-content-between validation-row mt-2 mb-1" :class="showOtpSectionPhone ? 'rep-otp-validation mb-3' : 'mb-1'" id="phoneOTP">
              <a  v-if="showOtpSectionPhone  "
                href="#" 
                class="validate-via-otp-link validate-btn " 
                @click.prevent="sendOtp('phone')"
              >
                TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE.
              </a>

            </div>
            <!-- to show the phone validation message -->
            <div v-if="phoneMsg" class="contacts-message-container form-group">
                   <div :class="['validate-message', phoneValidationMessage.type]">
                   <div :class="['message-indicator', `${phoneValidationMessage.type}-indicator`]"></div>
                   <span class="message-text">
                   <strong :class="`${phoneValidationMessage.type}-text`">{{ phoneValidationMessage.title }}</strong> - 
                      {{ phoneValidationMessage.message }}
                   </span>
               </div>
           </div>
            <div class="form-group text-center mb-3 mt-3">
              <b-button  class="univ-btn" 
              type="submit"
               :disabled="!form.email || !form.phone">
                {{ isCreate ? "Creating..." : "Create" }}
   
              </b-button>
            </div>
          </form>
        <!-- This div will replace the email/phone inputs when OTP validation is triggered -->
      <div v-if="showOtpModal" class="otp-verification-section">
        <!-- OTP Verification Header -->

  <!-- OTP Box -->
  <div class="rep-admin-otp-container ">
    <div v-if="!verificationSkipped">
    <div class="otp-modal-content">
      <h6 >Verify OTP</h6>
      <p class="text-muted mb-2">
        Validate your {{ otpType }} via OTP
        <br />
        OTP has been sent to <strong style="word-wrap: break-word;">{{ contactInfo }}</strong>
      </p>
       <div >
        <label class="mb-2 mt-3" id="enterotplabel">Please enter the 6 digit OTP:</label>
        <div class="d-flex mb-3 otp-inputs-wrapper align-items-center gap-2">
        <input  
          v-for="(digit, index) in otpDigits" 
          :key="index"
          v-model.number="otpDigits[index]"
          class="form-control otp-input"
          maxlength="1"
          min="0"
          max="9"
          @input="handleOtpInput(index, $event)"
          @keydown.delete="handleOtpDelete(index, $event)"
          @keydown="preventNonNumeric($event)"
          @paste="handlePaste($event)"
          ref="otpInputs"
          :disabled="otpVerified"
          inputmode="numeric"
          pattern="\d*"
        />
      </div>
       </div>
   
      <!-- Verify Button -->
      <div class="d-flex mt-4 gap-2 flex-wrap justify-content-center" >
        <b-button class="univ-btn verify-btn m-0"   id="verifyotpbtn" 
          :disabled="!isOtpComplete || otpVerificationInProgress || otpVerified"
          @click.prevent="verifyOtp">
          <span v-if="otpVerificationInProgress">Verifying...</span>
          <span v-else-if="otpVerified">Verified</span>
          <span v-else>Verify OTP</span>
        </b-button>
          </div>

            <!-- OTP Validation Message -->
        <div v-if="otpValidationMessage && otpAttempted" class="otp-message-container">
        <div :class="['validate-message', otpValidationMessage.type]" style=" margin-top: 1rem;">
          <div :class="['message-indicator', `${otpValidationMessage.type}-indicator`]"></div>
          <span class="message-text">
            <strong :class="`${otpValidationMessage.type}-text`">{{ otpValidationMessage.title }}</strong> - 
            {{ otpValidationMessage.message }}
          </span>
        </div>
    
        </div>
        </div>
        </div>
        </div>

          <!-- Cancel and Save Buttons -->
          <div class="button-group mt-3 d-flex justify-content-center align-items-center  gap-3">
            <b-button
              class="btn btn-secondary cancel-btn mt-0"
              @click="showOriginalModal"
            >
              Cancel
            </b-button>
            <b-button 
            
              class="univ-btn mt-0"
              id="saveChangesBtn"
              @click="saveChanges"
              :disabled="!canSaveChanges"
            >
              Save changes
            </b-button>
          </div>
    </div>
     </ValidationObserver>
      </div>
    </b-container>
  </b-modal>
</template>
<script>
import Api from "@/resource/Api";
import ApiSendOtp from "@/resource/BaseApi";

export default {
  name: "RepAdminAddNuera",
  data: () => ({
    form: {
      email: "",
      phone: "",
      skip_validation_email: false,
      skip_validation_phone: false,
      
    },
    isCreate: false,

    otpDigits: Array(6).fill(''),
    phoneMsg: false,
    emailMsg:false,
    emailValidationMessage: null,
    phoneValidationMessage: null,
    showOtpModal: false,
    // skipEmailVerification: false,
    // skipPhoneVerification: false,
    otpValidationMessage: null,
    otpAttempted: false,
    otpVerified: false,
    otpVerificationInProgress: false,
    contactInfo: null,
    otpType: null,
 
    skipValidationMessage: null,
    validationStatus: null,
    canSaveChanges: false,
    showOtpSectionEmail: false,
    showOtpSectionPhone: false,
    skipVerification: false,
    verificationSkipped: false,
    phoneVerified: false,
    emailVerified: false,
  
  }),
  computed: {
    isOtpComplete() {
      return this.otpDigits.every(d => d !== "");
    },
  },

  watch: {
  "form.phone": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form.skip_validation_phone=false;   
           }
    },
    immediate: true
  },
  "form.email": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form.skip_validation_email=false;
              }
    },
    immediate: true
  }
},

  methods: {
onlyAllowDigits(event) {
  const char = String.fromCharCode(event.which);
  
  // Allow only digits (0-9)
  if (!/[0-9]/.test(char)) {
    event.preventDefault();
    return;
  }

  // Restrict to max 10 digits
  if (this.form.phone.length >= 10) {
    event.preventDefault();
  }
},

 saveChanges() {
let success=false; 
  if (this.phoneVerified) {
     this.phoneValidationMessage = {
      type: 'success',
      title: 'Success',
      message: 'Phone verified successfully.' 
     };
     this.otpType = null;
  this.contactInfo = null;
  this.otpVerified=false;
  this.otpAttempted = false;
  this.otpValidationMessage = null;

  this.form.skip_validation_phone = true;
  

 
  this.showOtpSectionPhone = false;
  this.showOtpModal = false;
  success=true
 
  } 
   if (this.emailVerified) {
    this.emailValidationMessage = {
      type: 'success',
      title: 'Success',
      message: 'Email verified successfully.' 
     };
  this.showOtpSectionEmail = false;
  this.showOtpModal=false;
  this.otpType = null;
  this.contactInfo = null;
  this.otpVerified=false;
  this.otpAttempted = false;
  this.otpValidationMessage = null;
  success=true;
  this.form.skip_validation_email = true;
  }

  if(success){
    this.$notify('Changes saved successfully!','success');
  }
},
    showOriginalModal(){
  this.showOtpModal = false;
  this.otpVerified=false;
  this.otpAttempted = false;  
  this.otpValidationMessage = null;
  this.skipEmailVerification = false;
  this.skipPhoneVerification = false;
  this.otpVerificationInProgress  = false;
  this.canSaveChanges = false; // Disable save changes button
  this.skipValidationMessage = null;
  this.otpType = null;
  this.contactInfo = null;
    },

    openOtpModal(type) {
      if (type === 'email') {
        this.showOtpModal = true;
        this.contactInfo = this.form.email;
        this.otpType = 'email';
        

      } else if (type === 'phone') {
        this.showOtpModal = true;
        this.contactInfo = this.form.phone;
        this.otpType = 'phone';
      }
      this.otpDigits = Array(6).fill('');
    },
    closeOtpModal() {
   this.reset();
      this.showOtpModal = false;
    },
    handleOtpInput(index, event) {
      // Sanitize input to numbers only
      const sanitizedValue = event.target.value.replace(/\D/g, '')
      this.otpDigits[index] = sanitizedValue
      
      // Ensure only one digit is entered
      if (event.target.value.length > 1) {
        this.otpDigits[index] = event.target.value.slice(0, 1)
        return
      }

      // Move to next input when a digit is entered
      if (sanitizedValue && index < 5) {
        this.$nextTick(() => {
          this.$refs.otpInputs[index + 1].focus()
        })
      }
      
      // Emit complete event if all digits filled
      if (this.otpDigits.every(d => d) && index === 5) {
        this.$emit('complete', this.otpDigits.join(''))
      }
    },
    handleOtpDelete(index, event) {
      // Move to previous input when backspace is pressed on an empty field
      if (!event.target.value && index > 0) {
        this.$nextTick(() => {
          this.$refs.otpInputs[index - 1].focus();
        });
      }
    },
    preventNonNumeric(event) {
      // Allow: backspace, delete, tab, escape, enter
      if (
        [8, 9, 13, 27, 46].includes(event.keyCode) ||
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (event.ctrlKey && [65, 67, 86, 88].includes(event.keyCode)) ||
        // Allow: left/right arrows
        (event.keyCode >= 37 && event.keyCode <= 40)
      ) {
        return;
      }
      // Block non-numeric keys
      if (
        (event.keyCode < 48 || event.keyCode > 57) && // 0-9
        (event.keyCode < 96 || event.keyCode > 105)   // Numpad 0-9
      ) {
        event.preventDefault();
      }
    },
    handlePaste(event) {
      event.preventDefault();
      
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      
      const numericText = pastedText.replace(/[^0-9]/g, '');
      
      const otpText = numericText.slice(0, 6);
      
      this.fillOtpInputs(otpText);
    },
    fillOtpInputs(otpText) {
      this.otpDigits = Array(6).fill('');
      
      for (let i = 0; i < Math.min(otpText.length, 6); i++) {
        this.otpDigits[i] = otpText[i];
      }
      
      const focusIndex = Math.min(otpText.length, 5);
      this.$nextTick(() => {
        if (this.$refs.otpInputs && this.$refs.otpInputs[focusIndex]) {
          this.$refs.otpInputs[focusIndex].focus();
        }
      });
    },
     // method to send the otp


async sendOtp(type) {
     
  // Reset OTP state when switching between email and phone
  this.otpDigits = Array(6).fill('');
  this.otpVerified = false;
  this.otpAttempted = false;
  this.otpValidationMessage = null;
  this.verificationSkipped = false;
  this.skipValidationMessage = null;
  this.otpVerificationInProgress = false;

  if (type === 'email') {

    this.openOtpModal('email');
  } 
  else{

    this.openOtpModal('phone');
  }

  try {
    const response = await ApiSendOtp.post('api/v2/send-common-otp', {
      contact: this.contactInfo,
      type: this.otpType,
      no_attempt_limit: 1,
      expiry_duration: 600,

    });
    
    if (response.data.success === true || response.data.status === 'success') {
      this.$notify('OTP sent successfully!');
    } else {
      this.$notify(response.data.message || 'Failed to send OTP. Please try again.', 'error');
    }
  } catch (error) {
    this.$notify('Failed to send OTP. Please try again.', 'error');
    console.error('OTP send error:', error);
  }
},

  // this is the function to verify otp
 async verifyOtp() {

this.otpVerificationInProgress = true;
this.otpAttempted = true;

try{
  const response = await ApiSendOtp.post('api/v2/verify-common-otp', {
 no_attempt_limit: 1,
 
// expiry_duration: 600,
contact: this.contactInfo,
type: this.otpType,
otp: parseInt(this.otpDigits.join('')),
});

if (response.data.success === true || response.data.status === 'success' || response.data.verified === true) {
this.otpVerified = true;
this.skipVerification = false; 
this.otpValidationMessage = {
  type: 'success',
  title: 'OTP Verified',
  message: 'Your OTP has been successfully verified.'
};
this.$notify('OTP verified successfully!');
this.canSaveChanges = true; // Enable save changes button

if (this.otpType === 'email') {
   this.emailVerified = true;
  } 
          
else if (this.otpType === 'phone') {
            this.phoneVerified = true;
}}}
catch(error){
this.phoneVerified= false;
this.emailVerified= false;
let errorMessage = 'An error occurred during OTP verification.';
if (error.response?.data?.message) {
errorMessage = error.response.data.message;
}

if(this.otpType === 'email'){
  // this.skipEmailVerification = true;
this.otpValidationMessage = {
type: 'error',
title: 'Verification Error',
message: 'Invalid OTP. Please try again.'
};
}

else if(this.otpType === 'phone'){
  // this.skipPhoneVerification = true;

this.otpValidationMessage = {
type: 'error',
title: 'Verification Error',
message: errorMessage
};
}
} finally {
this.otpVerificationInProgress = false;
}

},
    closeModal() {
      this.reset();
      this.$emit("onCloseModal");
    },
    reset() {
      this.form = {
        email: "",
        phone: "",
      };
      this.otpDigits = Array(6).fill("");
      this.showOtpSectionEmail = false;
      this.phoneMsg = false;
      this.phoneValidationMessage = null;
      this.emailValidationMessage = null;
      this.emailMsg = false;
      this.skipVerification = false;
      this.otpVerified = false;
      this.showOtpSectionPhone = false;
      this.$refs.observer.reset();
      this.$bvModal.hide("addRepNuera");
      this.showOtpModal = false;
      this.otpVerified=false;
      this.otpAttempted = false;  
      this.otpValidationMessage = null;
      this.skipEmailVerification = false;
      this.skipPhoneVerification = false;
      this.otpVerificationInProgress  = false;
      this.canSaveChanges = false; // Disable save changes button
      this.skipValidationMessage = null;
      this.otpType = null;
      this.contactInfo = null;
    },


  async  create() {
    this.showOtpSectionEmail = false;
    this.showOtpSectionPhone = false;
    this.emailMsg = false;
    this.phoneMsg = false;
    this.emailValidationMessage = null;
    this.phoneValidationMessage = null;
    // this.form.skip_validation_email = this.emailVerified;
    // this.form.skip_validation_phone = this.phoneVerified;
    const url = "v3/add-agent-user";
    let loader = this.$loading.show({
        container: this.$refs.addRepAdminContainer,
      });
      this.isCreate = true;
      await Api.post(url, this.form)
     .then((res) => {
          this.reset();
          this.$emit("onSuccess");
          this.$notify(res.data.message);
          this.phoneVerified = false;
          this.emailVerified = false;
          this.form.skip_validation_email=false;
          this.form.skip_validation_phone=false;

        })
        .catch((err) => {

        const emailError = err.response?.data?.errors?.email;
        const phoneError = err.response?.data?.errors?.phone;
        
    // Check for undefined errors
    if (phoneError && phoneError.includes("invalid") && !emailError) {
        this.form.skip_validation_email=true;
        this.form.skip_validation_phone=false;  
        this.$notify("Phone is invalid. Please validate via OTP", "error");
        this.phoneMsg = true;
      
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid phone number, please validate via OTP.",
          };
          this.showOtpSectionPhone = true;
        


    } else if (emailError && emailError.includes("invalid") && !phoneError) {

        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=true;  
        this.$notify("Email is invalid. Please validate via OTP", "error");
        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid email address, please validate via OTP.",
          };
          this.showOtpSectionEmail = true;

    } else if (emailError && emailError.includes("taken") && !phoneError) {
        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=true;  
        this.$notify("Email has been already taken.", "error");
        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Email has been already taken.",
          };
    } else if (phoneError && phoneError.includes("taken") && !emailError) {
        this.form.skip_validation_email=true;
        this.form.skip_validation_phone=false;   
        this.$notify("Phone has been already taken.", "error");
        this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Phone has been already taken.",
          };

    } else if (emailError && emailError.includes("taken") && phoneError && phoneError.includes("taken")) {

        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;       
        this.$notify("Email and Phone have already been taken.", "error");
        this.emailMsg = true;
        this.phoneMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Email has been already taken.",
          };
          this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Phone has been already taken.",
          };

    } else if (emailError && emailError.includes("invalid") && phoneError && phoneError.includes("invalid")) {

        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;  
        this.$notify("Email and Phone are invalid.", "error");
        this.emailMsg = true;
        this.phoneMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid email address, please validate via OTP.",
          };
          this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid phone number, please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
          this.showOtpSectionPhone = true;
          
    } else if (emailError && emailError.includes("taken") && phoneError && phoneError.includes("invalid")) {
        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;  
        this.$notify("Email has been already taken and Phone is invalid.", "error");
        this.emailMsg = true;
        this.phoneMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Email has been already taken.",
          };
          this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid phone number, please validate via OTP.",
          };
          this.showOtpSectionPhone = true;

    } else if (phoneError && phoneError.includes("taken") && emailError && emailError.includes("invalid")) {
        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;  
        this.$notify("Phone has been already taken and Email is invalid.", "error");
        this.emailMsg = true;
        this.phoneMsg = true;

        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Phone has been already taken.",
          };
          this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid email address, please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
    } else {
        this.form.skip_validation_email=false;
        this.form.skip_validation_phone=false;  
        this.$notify("An unknown error has occurred.", "error");
    }
      



        
        })
        .finally(() => {
          this.isCreate = false;
          setTimeout(() => {
            loader.hide();
          }, 2000);
        });
    },
  },
};
</script>
<style scoped>


::v-deep input.form-control.is-valid,
::v-deep .was-validated input.form-control:valid {
  border-color: gray !important;
  background-image: none !important;
  padding-right: 0 !important;
}

::v-deep .modal-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: start;
    padding: 1rem 1rem 0 1rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
}




/* .skip-verify{
  margin-left: 3rem;
  
}
.skip-verify .custom-control-input {

  width: 2rem;
  transform: scale(0.5); 
  margin-right: 1px;     


}

.skip-verify .custom-control-label {

  font-size: 0.9rem; 
  vertical-align: middle;
  margin-top: 4px;
  

} */


.cancel-btn {
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  text-align: center;
  padding: 10px;
  width: 100%;
  transition: all ease 0.6s;

}


/* .skip-email-verify label{
  margin: 0 !important; 
} */


.validate-message {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0.75rem 1rem;
  position: relative;
  margin-bottom: 0.75rem;
}

.message-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.message-text {
  flex-grow: 1;
  color: #495057;
}

.error-text {
  color: #dc3545;
  font-size: 0.875rem !important;
}

.success-text {
  color: #28a745;
}

.warning-text {
  color: #856404;
}

.error-indicator {
  background-color: #dc3545;
}

.success-indicator {
  background-color: #28a745;
}


.warning-indicator {
  background-color: #ffc107;
}
.validate-via-otp-link.validate-btn{
  color: #03c3ec;
}
.otp-inputs-wrapper {
  display: flex;
  margin-top: 0.5rem;
  gap: 1rem;
  justify-content: space-between;
  width: 100%;
}
.otp-inputs-wrapper .otp-input {
  height: 100%;
  aspect-ratio: 1/1;
  width: 55px;
  text-align: center;
  font-size: 1.25rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.otp-inputs-wrapper .otp-input:focus{
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}


  .rep-admin-otp-container .verify-btn{
      max-width: 100% ;
    }
    
  .rep-otp-validation {
    border: 2px solid #e31717;
    margin: 0 auto;
    padding: 5px;
    width: fit-content;
  }

  .rep-otp-validation:hover {
    border: 2px solid #a50e0e;
    box-shadow: #eb2a2a;
    background-color: aliceblue;
    cursor: pointer;
  }

  @media (max-width :576px) {
    .otp-inputs-wrapper .otp-input {
      height: 100%;
      width: 100%;
      max-width: 64px;
      aspect-ratio: 1/1;
      font-size: 1.2rem;
    }
  }

@media screen and (max-width: 374px) {

  .otp-verification-section .button-group{
    flex-direction: column;
  }
    /* .otp-inputs-wrapper .otp-input {
      width: 34px;
      height: 34px;
      margin: 0;
    } */
}

</style>